import { ColumnMapping } from 'app/[lang]/(main)/translation/new/[[...args]]/_components/HubDbColumnMapping';
import { UploadedFileMetadataUpdateInput } from 'gql/graphql';

interface TransformedData {
  [sourceColumn: string]: {
    [targetColumn: string]: string;
  };
}

export const getMetadataHubDb = (
  metadata: Record<string, any>[],
  columnMapping: ColumnMapping[],
  selectedFile?: { id?: string }
): UploadedFileMetadataUpdateInput => {
  if (!metadata?.length) return {} as UploadedFileMetadataUpdateInput;

  const hubdbColumnMapping = columnMapping.reduce<TransformedData>((acc, item) => {
    const source = item.sourceColumn;

    // Initialize source object if it doesn't exist
    if (!acc[source]) acc[source] = {};

    // Add each target to the source object
    item.targetsColumn.forEach((target) => (acc[source][target.language] = target.column));

    return acc;
  }, {});

  const metadataNew = {
    'hubdb-column-mapping': hubdbColumnMapping
  };

  const result = {
    fileId: selectedFile?.id as string,
    metadata: metadataNew
  };

  return result;
};
